import Vue from "vue";
import Vuex from "vuex";
import modules from './modules';
// import createPersistedState from 'vuex-persistedstate'
import imageHelper from '@/helpers/imageHelper'
import router from '@/router'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    Loading: true,
    Title: '',
    TopImage: '/media/haxdap2u/1324821-6026651-zgnxts76oz.jpg'
  },
  actions: {
    async init({ commit, dispatch }){
      await dispatch('initRecipes')
      await dispatch('setSortedCategories')
      await dispatch('checkUserAccess')
      dispatch('checkUmbracoConnection')
      commit('setLoading', false)
    }
  },
  mutations: {
    setTitle(state, title){
      document.title = `Marias Opskrifter | ${title}`
      state.Title = title
    },
    setLoading(state, is){
      state.Loading = is
    }
  },
  getters: {
    loadingState: state => state.Loading,
    pageTitle: state => state.Title,
    topImage: (state, getters) => {
      if(router.app.$route.name == 'Recipe'){
        return imageHelper.imageBackground(getters.getRecipeById(router.app.$route.params.url).ImageUrl)
      }
      else
        return imageHelper.imageBackground(state.TopImage)
    },
  },
  modules: modules,
  // plugins: [createPersistedState()]
});
